export * from './simple-slider'



// WEBPACK FOOTER //
// ./src/app/shared/components/simple-slider/index.ts